/** `integration` module DTO schemas unique keys */
export enum IntergrationDtoKeyEnum {
  /** Atrium CRM connection response body */
  ATRIUM_CONNECTION_FIND_DTO = 'integration/atrium-connection-find.dto',
  /** Atrium CRM connection create and update request body */
  ATRIUM_CONNECTION_FORM_DTO = 'integration/atrium-connection-form.dto',
  /** Atrium exchange history entries own filters */
  ATRIUM_EXCHANGE_HISTORY_FILTERS_DTO = 'integration/atrium-exchange-history-filters.dto',
  /** Atrium exchange history entry response body */
  ATRIUM_EXCHANGE_HISTORY_FIND_DTO = 'integration/atrium-exchange-history-find.dto',
  /** Atrium exchange history entries slice */
  ATRIUM_EXCHANGE_HISTORY_PAGE_DTO = 'integration/atrium-exchange-history-page.dto',
  /** Atrium exchange history entries API query parameters */
  ATRIUM_EXCHANGE_HISTORY_QUERY_DTO = 'integration/atrium-exchange-history-query.dto',
  /** Request body for API which creates deal by feedback form data from 1C Bitrix CMS side */
  BITRIX_CREATE_DEAL_BY_SITE_FEEDBACK_FORM_DTO = 'integration/bitrix-create-deal-by-site-feedback-form.dto',
  /** 1C ERP database connection credentials test result */
  CONNECTION_1C_CREDENTIALS_TEST_RESULT_DTO = 'integration/connection-1c-credentials-test-result.dto',
  /** 1C ERP database connection credentials base data */
  CONNECTION_1C_CREDENTIALS_DTO = 'integration/connection-1c-credentials.dto',
  /** 1C ERP database connection credentials response body */
  CONNECTION_1C_FIND_DTO = 'integration/connection-1c-find.dto',
  /** 1C ERP database connection credentials create or update request body */
  CONNECTION_1C_FORM_DTO = 'integration/connection-1c-form.dto',
  /** 1C ERP database connection credentials list API query parameters */
  CONNECTION_1C_QUERY_DTO = 'integration/connection-1c-query.dto',
  /** 1C ERP database connection registry column selection parameters */
  CONNECTION_1C_SELECT_DTO = 'integration/connection-1c-select.dto',
  /** 1C ERP database connection registry sorting settings */
  CONNECTION_1C_SORT_DTO = 'integration/connection-1c-sort.dto',
  /** 1C ERP database connection registry API query parameters */
  CONNECTION_1C_REGISTRY_QUERY_DTO = 'integration/connection-1c-registry-query.dto',
  /** 1C ERP database connection export API query parameters */
  CONNECTION_1C_EXPORT_QUERY_DTO = 'integration/connection-1c-export-query.dto',
  /** 1C ERP database connection registry items page */
  CONNECTION_1C_PAGE_DTO = 'integration/connection-1c-page.dto',
  /** 1C ERP database connection flat list API query parameters */
  CONNECTION_1C_FLAT_LIST_QUERY_DTO = 'integration/connection-1c-flat-list-query.dto',
  /** 1C ERP database developer console request body */
  CONNECTION_1C_CONSOLE_FORM_DTO = 'integration/connection-1c-console-form.dto',
  /** 1C ERP database developer console response body */
  CONNECTION_1C_CONSOLE_RESULT_DTO = 'integration/connection-1c-console-result.dto',
  /** Mailbox create and update API request body */
  EMAIL_FORM_DTO = 'integration/email-form.dto',
  /** Mailbox response body */
  EMAIL_FIND_DTO = 'integration/email-find.dto',
  /** Mailbox SMTP test API response body */
  EMAIL_TEST_SMTP_RESULT_DTO = 'integration/email-test-smtp-result.dto',
  /** ERP 1C exchange log history base filters */
  ERP_1C_EXCHANGE_LOG_FILTERS_DTO = 'integration/erp-1c-exchange-log-filters.dto',
  /** ERP 1C exchange log entry response body */
  ERP_1C_EXCHANGE_LOG_FIND_DTO = 'integration/erp-1c-exchange-log-find.dto',
  /** ERP 1C exchange log history API response body */
  ERP_1C_EXCHANGE_LOG_PAGE_DTO = 'integration/erp-1c-exchange-log-page.dto',
  /** ERP 1C exchange log history API query parameters */
  ERP_1C_EXCHANGE_LOG_QUERY_DTO = 'integration/erp-1c-exchange-log-query.dto',
  /** ERP 1C exchange log subtotal API response item */
  ERP_1C_EXCHANGE_LOG_SUBTOTAL_ITEM_DTO = 'integration/erp-1c-exchange-log-subtotal-item.dto',
  /** ERP 1C exchange log subtotal API query parameters */
  ERP_1C_EXCHANGE_LOG_SUBTOTAL_QUERY_DTO = 'integration/erp-1c-exchange-log-subtotal-query.dto',
  /** ERP 1C exchange log registry column selection parameters */
  ERP_1C_EXCHANGE_LOG_SELECT_DTO = 'integration/erp-1c-exchange-log-select.dto',
  /** ERP 1C exchange log registry sorting settings */
  ERP_1C_EXCHANGE_LOG_SORT_DTO = 'integration/erp-1c-exchange-log-sort.dto',
  /** ERP 1C exchange log registry API query parameters */
  ERP_1C_EXCHANGE_LOG_REGISTRY_QUERY_DTO = 'integration/erp-1c-exchange-log-registry-query.dto',
  /** ERP 1C exchange log export API query parameters */
  ERP_1C_EXCHANGE_LOG_EXPORT_QUERY_DTO = 'integration/erp-1c-exchange-log-export-query.dto',
  /** ERP 1C exchange log registry items page */
  ERP_1C_EXCHANGE_LOG_REGISTRY_PAGE_DTO = 'integration/erp-1c-exchange-log-registry-page.dto',
  /** ERP 1C exchange log subtotal API response body */
  ERP_1C_EXCHANGE_LOG_SUBTOTAL_DTO = 'integration/erp-1c-exchange-log-subtotal.dto',
  /** ERP 1C exchange log subtotal grouping settings */
  ERP_1C_EXCHANGE_LOG_GROUPING_DTO = 'integration/erp-1c-exchange-log-grouping.dto',
  /** 1C ERP full import queue statistics */
  ERP_1C_IMPORT_QUEUE_FULL_STAT_DTO = 'integration/erp-1c-import-queue-full-stat.dto',
  /** 1C ERP quotas for import queues */
  ERP_1C_IMPORT_QUEUE_QUOTAS_DTO = 'integration/erp-1c-import-queue-quotas.dto',
  /** 1C ERP import queue API URL parameters */
  ERP_1C_IMPORT_QUEUE_STAT_PARAMS_DTO = 'integration/erp-1c-import-queue-stat-params.dto',
  /** 1C ERP import queue statistics per 1C ERP database */
  ERP_1C_IMPORT_QUEUE_STAT_PER_CONNECTION_DTO = 'integration/erp-1c-import-queue-stat-per-connection.dto',
  /** 1C ERP import queue statistics */
  ERP_1C_IMPORT_QUEUE_STAT_DTO = 'integration/erp-1c-import-queue-stat.dto',
  /** Plaftorma OFD CRM connection create request body */
  PLATFORMA_OFD_CONNECTION_FORM_DTO = 'integration/platforma-ofd-connection-form.dto',
  /** "Leber" BRS task creation form request body */
  LEBER_BRS_TASK_FORM_DTO = 'integration/leber-brs-task-form.dto',
  /** Leber BRS task list API request body with filters */
  LEBER_BRS_TASK_LIST_FILTERS_DTO = 'integration/leber-brs-task-list-filters.dto',
  /** Leber BRS task list API item response body */
  LEBER_BRS_TASK_LIST_ITEM_DTO = 'integration/leber-brs-task-list-item.dto',
  /** Leber BRS task order response body */
  LEBER_BRS_TASK_ORDER_DTO = 'integration/leber-brs-task-order.dto',
  /** Leber BRS task find one API response body */
  LEBER_BRS_TASK_DTO = 'integration/leber-brs-task.dto',
  /** "Leber" deal creation API request body */
  LEBER_CREATE_DEAL_FORM_DTO = 'integration/leber-create-deal-form.dto',
  /** "Leber" documents list API response body item */
  LEBER_GET_DOCUMENTS_ITEM_DTO = 'integration/leber-get-documents-item.dto',
  /** "Leber" documents list API query parameters */
  LEBER_GET_DOCUMENTS_QUERY_DTO = 'integration/leber-get-documents-query.dto',
  /** MainSMS account response body */
  MAIN_SMS_ACCOUNT_FIND_DTO = 'integration/main-sms-account-find.dto',
  /** MainSMS account create and update APIs request body */
  MAIN_SMS_ACCOUNT_FORM_DTO = 'integration/main-sms-account-form.dto',
  /** MainSMS accounts list API query parameters */
  MAIN_SMS_ACCOUNT_QUERY_DTO = 'integration/main-sms-account-query.dto',
  /** 1C ERP plugin description find many API query parameters */
  PLUGIN_1C_FIND_MANY_QUERY_DTO = 'integration/plugin-1c-find-many-query.dto',
  /** 1C ERP plugin description response body */
  PLUGIN_1C_FIND_DTO = 'integration/plugin-1c-find.dto',
  /** 1C ERP plugin description create and update APIs request body */
  PLUGIN_1C_FORM_DTO = 'integration/plugin-1c-form.dto',
  /** Extended frontend version of the 1C ERP plugin description create and update APIs request body */
  PLUGIN_1C_FRONTEND_FORM_DTO = 'integration/plugin-1c-frontend-form.dto',
  /** 1C ERP plugin description find many API response body */
  PLUGIN_1C_PAGE_DTO = 'integration/plugin-1c-page.dto',
  /** 1C ERP plugin single APis URL parameters */
  PLUGIN_1C_PARAMS_DTO = 'integration/plugin-1c-params.dto',
  /** 1C ERP plugin selection settings */
  PLUGIN_1C_SELECT_DTO = 'integration/plugin-1c-select.dto',
  /** 1C ERP plugin sorting settings */
  PLUGIN_1C_SORT_DTO = 'integration/plugin-1c-sort.dto',
  /** Amo credentails response body */
  AMO_CREDENTAILS_FIND_DTO = 'integration/amo-credentails-find.dto',
  /** Amo credentails create API request body */
  AMO_CREDENTAILS_FORM_DTO = 'integration/amo-credentails-form.dto',
  /** Amo deal status response body */
  AMO_DEAL_STATUS_FIND_DTO = 'integration/amo-deal-status-find.dto',
  /** Amo pipeline response body */
  AMO_PIPELINE_FIND_DTO = 'integration/amo-pipeline-find.dto',
  /** Amo deal status create or update response body */
  AMO_DEAL_STATUS_FORM_DTO = 'integration/amo-deal-status-form.dto',
  /** Megaplan credentails response body */
  MEGAPLAN_CREDENTAILS_FIND_DTO = 'integration/megaplan-credentails-find.dto',
  /** Megaplan credentails create or update response body */
  MEGAPLAN_CREDENTAILS_FORM_DTO = 'integration/megaplan-credentails-form.dto',
  /** Megaplan program response body */
  MEGAPLAN_PROGRAM_FIND_DTO = 'integration/megaplan-program-find.dto',
  /** Megaplan program create or update body */
  MEGAPLAN_PROGRAM_FORM_DTO = 'integration/megaplan-program-form.dto',
  /** Megaplan status response body */
  MEGAPLAN_STATUS_FIND_DTO = 'integration/megaplan-status-find.dto',
  /** Google Calendar find one APIs query parameters */
  GOOGLE_CALENDAR_FIND_ONE_QUERY_DTO = 'integration/google-calendar-find-one-query.dto',
  /** Google Calendar response body */
  GOOGLE_CALENDAR_FIND_DTO = 'integration/google-calendar-find.dto',
  /** Google Calendar selection settings */
  GOOGLE_CALENDAR_SELECT_DTO = 'integration/google-calendar-select.dto',
  /** Google API connection find one API query parameters */
  GOOGLE_CONNECTION_FIND_ONE_QUERY_PARAMS = 'integration/google-connection-find-one-query.params',
  /** Google API connection response body */
  GOOGLE_CONNECTION_FIND_DTO = 'integration/google-connection-find.dto',
  /** Google API connection create and update APIs request body */
  GOOGLE_CONNECTION_FORM_DTO = 'integration/google-connection-form.dto',
  /** Google API connection selection settings */
  GOOGLE_CONNECTION_SELECT_DTO = 'integration/google-connection-select.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account find many API query parameters */
  SPEECH_2_TEXT_RU_ACCOUNT_FIND_MANY_QUERY_DTO = 'integration/speech-2-text-ru-account-find-many-query.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account find one API query parameters */
  SPEECH_2_TEXT_RU_ACCOUNT_FIND_ONE_QUERY_DTO = 'integration/speech-2-text-ru-account-find-one-query.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account response body */
  SPEECH_2_TEXT_RU_ACCOUNT_FIND_DTO = 'integration/speech-2-text-ru-account-find.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account create and update APIs request body */
  SPEECH_2_TEXT_RU_ACCOUNT_FORM_DTO = 'integration/speech-2-text-ru-account-form.dto',
  /** @link https://speech2text.ru "Speech2Text"} service account find many API response body */
  SPEECH_2_TEXT_RU_ACCOUNT_PAGE_DTO = 'integration/speech-2-text-ru-account-page.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account partial update APIs request body */
  SPEECH_2_TEXT_RU_ACCOUNT_PARTIAL_FORM_DTO = 'integration/speech-2-text-ru-account-partial-form.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account selection settings */
  SPEECH_2_TEXT_RU_ACCOUNT_SELECT_DTO = 'integration/speech-2-text-ru-account-select.dto',
  /** {@link https://speech2text.ru "Speech2Text"} service account sorting settings */
  SPEECH_2_TEXT_RU_ACCOUNT_SORT_DTO = 'integration/speech-2-text-ru-account-sort.dto',
  /** Telegram bot own filters */
  TELEGRAM_BOT_FILTERS_DTO = 'integration/telegram-bot-filters.dto',
  /** Telegram bot find many API query parameters */
  TELEGRAM_BOT_FIND_MANY_QUERY_DTO = 'integration/telegram-bot-find-many-query.dto',
  /** Telegram bot find one API query parameters */
  TELEGRAM_BOT_FIND_ONE_QUERY_DTO = 'integration/telegram-bot-find-one-query.dto',
  /** Telegram bot response body */
  TELEGRAM_BOT_FIND_DTO = 'integration/telegram-bot-find.dto',
  /** Telegram bot create and update APIs request body */
  TELEGRAM_BOT_FORM_DTO = 'integration/telegram-bot-form.dto',
  /** Telegram bot find many API response body */
  TELEGRAM_BOT_PAGE_DTO = 'integration/telegram-bot-page.dto',
  /** Telegram bot partial update API request body */
  TELEGRAM_BOT_PARTIAL_FORM_DTO = 'integration/telegram-bot-partial-form.dto',
  /** Telegram bot fields selection settings */
  TELEGRAM_BOT_SELECT_DTO = 'integration/telegram-bot-select.dto',
  /** Telegram bot sorting settings */
  TELEGRAM_BOT_SORT_DTO = 'integration/telegram-bot-sort.dto',
  /** Telegram chat response body */
  TELEGRAM_CHAT_DTO = 'integration/telegram-chat.dto',
  /** Basic entry fields in the Telegram webhook call history */
  TELEGRAM_BOT_WEBHOOK_HISTORY_ENTRY_BASE_DTO = 'integration/telegram-bot-webhook-history-entry-base.dto',
  /** The response body of a Telegram webhook call history entry */
  TELEGRAM_BOT_WEBHOOK_HISTORY_ENTRY_FIND_DTO = 'integration/telegram-bot-webhook-history-entry-find.dto',
  /** Telegram webhook call history API own filters */
  TELEGRAM_BOT_WEBHOOK_HISTORY_FILTERS_DTO = 'integration/telegram-bot-webhook-history-filters.dto',
  /** Telegram webhook call history API response body */
  TELEGRAM_BOT_WEBHOOK_HISTORY_PAGE_DTO = 'integration/telegram-bot-webhook-history-page.dto',
  /** Telegram webhook call history API query parameters */
  TELEGRAM_BOT_WEBHOOK_HISTORY_QUERY_DTO = 'integration/telegram-bot-webhook-history-query.dto',
  /** Modulbank operation history response body */
  MODULBANK_OPERATION_HISTORY_FIND_DTO = 'integration/modulbank-operation-history-find.dto',
  /** Modulbank operation history list API query parameters */
  MODULBANK_OPERATION_HISTORY_QUERY_DTO = 'integration/modulbank-operation-history-query.dto',
  /** Modulbank operation history list API response body */
  MODULBANK_OPERATION_HISTORY_PAGE_DTO = 'integration/modulbank-operation-history-page.dto',
  /** Alfabank statement API query parameters */
  ALFABANK_STATEMENT_QUERY_DTO = 'integration/alfabank-statement-query.dto',
  /** Alfabank statement list API response body */
  ALFABANK_STATEMENT_FIND_DTO = 'integration/alfabank-statement-find.dto',
  /** Alfabank statement list API response body */
  ALFABANK_STATEMENT_PAGE_DTO = 'integration/alfabank-statement-page.dto',
  /** Alfabank statement transaction API response body */
  ALFABANK_STATEMENT_TRANSACTION_FIND_DTO = 'integration/alfabank-statement-transaction-find.dto',
  /** Alfabank balance API response body */
  ALFABANK_BALANCE_FIND_DTO = 'integration/alfabank-balance-find.dto',
  /** Alfabank rur transfer API response body */
  ALFABANK_RUR_TRANSFER_FIND_DTO = 'integration/alfabank-rur-transfer-find.dto',
  /** Alfabank cart info API response body */
  ALFABANK_CART_INFO_FIND_DTO = 'integration/alfabank-cart-info-find.dto',
  /** Alfabank departmental info API response body */
  ALFABANK_DEPARTMENTAL_INFO_FIND_DTO = 'integration/alfabank-departmental-info-find.dto',
  /** Alfabank cur transfer API response body */
  ALFABANK_CUR_TRANSFER_FIND_DTO = 'integration/alfabank-cur-transfer-find.dto',
  /** Alfabank swift transfer API response body */
  ALFABANK_SWIFT_TRANSFER_FIND_DTO = 'integration/alfabank-swift-transfer-find.dto',
  /** Tbank statement API query parameters */
  TBANK_STATEMENT_QUERY_DTO = 'integration/tbank-statement-query.dto',
  /** Tbank statement list API response body */
  TBANK_STATEMENT_FIND_DTO = 'integration/tbank-statement-find.dto',
  /** Tbank statement list API response body */
  TBANK_STATEMENT_PAGE_DTO = 'integration/tbank-statement-page.dto',
  /** Tbank statement balance API response body */
  TBANK_STATEMENT_BALANCE_FIND_DTO = 'integration/tbank-statement-balance-find.dto',
  /** Tbank statement balance by day API response body */
  TBANK_STATEMENT_BALANCE_BY_DAY_FIND_DTO = 'integration/tbank-statement-balance-by-day-find.dto',
  /** Tbank statement operation API response body */
  TBANK_STATEMENT_OPERATION_FIND_DTO = 'integration/tbank-statement-operation-find.dto',
  /** Tbank statement payer API response body */
  TBANK_STATEMENT_PAYER_FIND_DTO = 'integration/tbank-statement-payer-find.dto',
  /** Tbank statement contragent API response body */
  TBANK_STATEMENT_CONTRAGENT_FIND_DTO = 'integration/tbank-statement-contragent-find.dto',
  /** Tbank statement merchant API response body */
  TBANK_STATEMENT_MERCHANT_FIND_DTO = 'integration/tbank-statement-merchant-find.dto',
  /** Tbank statement tax API response body */
  TBANK_STATEMENT_TAX_FIND_DTO = 'integration/tbank-statement-tax-find.dto',
}
